<template><svg style="width:30px;height:30px" viewBox="0 0 24 24"><path fill="#ffff01" d="M14 19h4V5h-4M6 19h4V5H6v14z"/></svg></template>